import {createMultiStyleConfigHelpers} from '@chakra-ui/react'
import {remCalc} from '../../_utils'

const helpers = createMultiStyleConfigHelpers([
    'header',
    'cart',
    'policies',
    'support',
    'paymentMethods',
    'shipping',
    'emptyCart',
])

const Cart = helpers.defineMultiStyleConfig({
    baseStyle: (props) => ({
        header: {
            headerContainer: {
                display: 'flex',
                flexDir: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: '100%',
                paddingY: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            },
            stack: {
                alignItems: 'center',
                gap: remCalc(8),
            },
            title: {
                color: 'text.default',
                textStyle: 'head-large',
                fontWeight: 'medium',
            },
            quantity: {
                color: 'text.default',
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
        },
        shipping: {
            shippingContainer: {
                w: '100%',
                display: 'flex',
                flexDir: 'row',
                padding: remCalc(8),
                alignItems: 'center',
                position: 'relative',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.success',
            },
            shippingContent: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: {
                    base: 'flex-start',
                    md: 'center',
                },
                flex: 1,
            },
            shippingIcon: {
                boxSize: 'iconsSize.large',
            },
            shippingText: {
                color: 'text.default',
                textStyle: 'body-small',
                fontWeight: 'bold',
            },
            closeIcon: {
                boxSize: 'iconsSize.large',
                ml: {
                    base: 0,
                    md: 'auto',
                },
            },
        },
        cart: {
            boxContainer: {
                display: 'flex',
                flexDir: 'column',
                // paddingX: {
                //     lg: remCalc(40),
                //     md: remCalc(40),
                //     sm: remCalc(16),
                //     base: remCalc(16),
                // },
                paddingTop: remCalc(8),
                width: '100%',
                maxW: remCalc(1400),
                h: 'auto',
                alignItems: 'flex-start',
                gap: remCalc(10),
                alignSelf: 'stretch',
                bg: 'background.default',
                margin: '0 auto',
            },
            cartMainStack: {
                spacing: remCalc(24),
                w: '100%',
            },
            cartContainer: {
                minWidth: '100%',
                height: '100%',
                paddingTop: {
                    lg: remCalc(8),
                    md: remCalc(8),
                    sm: remCalc(8),
                    base: remCalc(8),
                },
                paddingBottom: {
                    lg: remCalc(14),
                    md: remCalc(14),
                    sm: remCalc(8),
                    base: remCalc(8),
                },
            },
            containerGrid: {
                gap: ['small.base', 'small.sm', 'small.md', 'small.lg'],
                templateColumns: {base: '1fr', lg: '3fr 1fr'},
                templateRows: {lg: 'auto auto'},
            },
            checkoutItem: {
                display: 'flex',
                p: remCalc(24),
                flexDir: 'column',
                borderRadius: 'medium.lg',
                bg: 'background.light',
            },
            checkoutItemWhite: {
                display: 'flex',
                p: remCalc(24),
                flexDir: 'column',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                borderRadius: 'medium.lg',
                bg: 'background.default',
            },
            orderSummaryContainer: {
                width: {base: 'full', lg: remCalc(450)},
            },
        },
        emptyCart: {
            pageContainer: {
                layerStyle: 'page',
                display: 'flex',
                flexDir: 'column',
                w: '100%',
                h: 'auto',
                alignItems: {
                    lg: 'center',
                    md: 'center',
                    sm: 'flex-start',
                    base: 'flex-start',
                },
                gap: remCalc(10),
                alignSelf: 'stretch',
                paddingY: 0,
            },
            cartContainer: {
                display: 'flex',
                flexDir: {
                    lg: 'row',
                    md: 'column',
                    sm: 'column',
                    base: 'column',
                },
                alignItems: 'center',
                justifyContent: {
                    lg: 'center',
                },
                paddingY: {
                    lg: 0,
                    md: 0,
                    base: remCalc(24),
                },
                gap: remCalc(24),
                w: '100%',
                h: 'auto',
                flexWrap: {
                    sm: 'stretch',
                    base: 'stretch',
                },
            },
            leftStack: {
                flex: '2',
                spacing: 0,
                align: 'stretch',
                alignSelf:
                    props.removeMessagesLength > 0
                        ? ['center', 'center', 'center', 'flex-start']
                        : 'auto',
                maxWidth: [remCalc(451), remCalc(451), remCalc(451), 'unset'],
                width: '100%',
            },
            cartContent: {
                display: 'flex',
                flexDir: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'stretch',
                maxWidth: remCalc(925),
                width: 'auto',
                h: '100%',
                mt:
                    props.removeMessagesLength > 0
                        ? ['auto', 'auto', 'auto', remCalc(150)]
                        : 'auto',
            },
            removeMessagesBox: {
                pb: 'medium.base',
                alignItems: 'flex-start',
                textAlign: 'left',
                w: '100%',
            },
            checkoutContainer: {
                display: 'flex',
                flex: '2',
                maxWidth: remCalc(451),
                h: 'auto',
            },
            emptyStack: {
                gap: remCalc(24),
            },
            emptyIcon: {
                w: 'iconsSize.xlarge',
                h: 'iconsSize.xlarge',
                marginBottom: remCalc(16),
            },
            emptyText: {
                color: 'text.default',
                textAlign: 'center',
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
            discoverMoreButton: {
                _hover: {
                    textDecoration: 'none',
                    bg: 'button.text.text-hover',
                },
            },
            productsContainer: {
                display: 'flex',
                flexDir: 'row',
                alignSelf: 'flex-start',
                paddingBottom: 'medium.lg',
                width: 'auto',
                h: 'auto',
                pX: {
                    lg: 0,
                    md: 0,
                    sm: 'medium.sm',
                    base: 'medium.base',
                },
                pY: 0,
                gap: remCalc(24),
            },
        },
        policies: {
            policiesContainer: {
                gap: remCalc(24),
            },
            section: {
                color: 'text.default',
                align: 'start',
                display: 'flex',
                flexDir: 'column',
                alignItems: 'flex-start',
                gap: remCalc(12),
                alignSelf: 'stretch',
            },
            header: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(10),
                alignSelf: 'stretch',
            },
            title: {
                textStyle: 'body-medium',
                fontWeight: 'normal',
            },
            message: {
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
            icon: {
                w: 'iconsSize.medium',
                h: 'iconsSize.medium',
            },
            link: {
                textDecoration: 'underline',
            },
        },
        support: {
            supportContainer: {
                gap: remCalc(24),
                alignItems: 'left',
            },
            supportEmailSection: {
                justifyContent: 'space-between',
                alignItems: 'center',
                alignContent: 'center',
                rowGap: remCalc(24),
                alignSelf: 'stretch',
                flexWrap: {
                    lg: 'wrap',
                    md: 'wrap',
                    sm: 'no-wrap',
                    base: 'no-wrap',
                },
            },
            innerEmailStack: {
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                gap: remCalc(24),
                flexWrap: 'wrap',
            },
            supportChatSection: {
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                gap: remCalc(24),
                flexWrap: 'wrap',
            },
            supportIcon: {
                w: 'iconsSize.xlarge',
                h: 'iconsSize.xlarge',
                color: 'button.text.text-default',
            },
            text: {
                minWidth: remCalc(100),
                maxWidth: remCalc(168),
                flex: '1 0 0',
                color: 'text.secondary',
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
            discoverMoreButton: {
                textStyle: 'body-xsmall',
                fontWeight: 'bold',
            },
        },
        paymentMethods: {
            stack: {
                alignItems: 'flex-start',
                gap: remCalc(24),
                alignSelf: 'stretch',
            },
            headerContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(10),
                alignSelf: 'stretch',
            },
            header: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 'medium',
            },
            iconContainer: {
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center',
                gap: remCalc(8),
                alignSelf: 'stretch',
                flexWrap: 'wrap',
            },
            icon: {
                w: remCalc(40),
                h: remCalc(26),
                flexShrink: 0,
            },
        },
    }),
    variants: {
        checkout: {
            cart: {
                checkoutItem: {
                    display: 'flex',
                    p: remCalc(24),
                    flexDir: 'column',
                    borderRadius: 'medium.lg',
                    bg: 'background.light',
                    mt: remCalc(8),
                },
            },
        },
    },
})
export default Cart
